<template lang="pug">
  .course-constructor(style="position: relative")
    v-app-bar(
      v-if="!readonly"
      color="secondary"
      dark
      app
      flat
    )
      v-container
        v-row(no-gutters align="center")
          v-btn(
            color="secondary lighten-2"
            depressed
            @click="onExit"
          ).mr-4
            v-icon(left) mdi-chevron-left
            span Сохранить и выйти
          div.d-none.d-sm-block
            .caption.grey--text Название
            span {{ course.title }}
          v-spacer
          .caption(v-if="loading.save") Идет сохранение...
    v-main.course-constructor__body
      C-section-title(
        ref="section-title"
        v-model="titleSection"
        :readonly="readonly"
      )
        template(#title-slot)
          slot(name="title-slot")

      template(v-if="course")
        v-slide-y-transition(group leave-absolute)
          C-section(
            v-for="(section, idx) in genericSections"
            v-model="genericSections[idx].value"
            :key="section.hash"
            :ref="`section-${section.hash}`"
            :id="`section-${idx}`"
            :cards-type="section.cardsType"
            :dark-bg="idx % 2 !== 0"
            :first="idx === 0"
            :last="idx === genericSections.length - 1"
            :course="course"
            :readonly="readonly"
            @move:after="moveSection(idx, idx + 1)"
            @move:before="moveSection(idx, idx - 1)"
            @remove="removeSection(idx)"
            @add:after="createSection(idx + 1)"
            @add:before="createSection(idx)"
          )
      div(ref="section-footer")
        slot(name="footer")
      div(
        v-if="viewBtn"
        style="position: fixed; bottom: 50px; right: 30px;"
      )
        tooltip-wrap(text="К записи на курс" )
          v-badge(
            color="error"
            icon="mdi-car-brake-alert"
            overlap
            offset-x="18"
            offset-y="18"
          )
            v-btn(
              fab color="secondary"
              @click="$vuetify.goTo(0, { duration: 450, easing: 'easeInOutCubic' })"
            ): v-icon mdi-arrow-up
</template>

<script>
import CInput from './CInput.vue';
import CSection from './CSection.vue';
import CSectionTitle from './CSectionTitle.vue';
import CPickSection from './CPickSection.vue';

import { defaultSectionsList } from './templates';
import { toInternalValue, toRepresentationValue } from './utils';

export default {
  components: {
    CInput,
    CSection,
    CSectionTitle,
  },
  props: {
    method: { type: Function, default: () => {} },
    course: { type: Object, required: true },
    constructorData: { type: Array, default: () => ([]) },
    readonly: { type: Boolean, default: false },
    defaultType: { type: String, default: 'course' },
    onExitMethod: {
      type: Function,
      default: () => {
        if (this.$user.isOrganization) {
          this.$router.push({
            name: 'MyCourseList',
          });
        } else {
          this.$router.push({
            name: 'Desktop',
          });
        }
      },
    },
  },
  data() {
    return {
      titleSection: {
        shadow_level: 70,
        title: 'Английский за 12 часов',
        background: null,
        description: 'А именно, как вагоноремонтному предприятию можно сэкономить 7 млн. рублей в год, снизить срок инвентаризации с двух недель до одного дня и минимизировать ошибки при проведении ремонта.',
      },
      genericSections: defaultSectionsList[this.defaultType],
      loading: {
        save: false,
      },
      options: {
        duration: 600,
        easing: 'easeOutQuart',
      },
      scrollAnimation: false,
      viewBtn: false,
    };
  },
  computed: {
    scrolls: {
      get() {
        const a = Object.entries(this.$refs).reduce((acc, [key, ref], idx) => {
          if (key.includes('section')) {
            const { $el } = ref[0] || ref;
            const additionalHeight = (this.readonly ? 0 : 64);
            acc.push([
              idx ? acc[idx - 1][1] : 0,
              ($el?.offsetHeight || ref.offsetHeight) + (idx ? acc[idx - 1][1] : additionalHeight),
            ]);
          }
          return acc;
        }, []);
        return a;
      },
    },
  },
  created() {
    this.titleSection.title = this.course.title || '(Введите название)';

    if (this.constructorData.length) {
      this.parseConstructorData();
    }
  },
  mounted() {
    window.addEventListener('wheel', this.scrollHandler, { passive: false });
  },
  beforeDestroy() {
    window.removeEventListener('wheel', this.scrollHandler, { passive: false });
  },
  methods: {
    scrollHandler(e) {
      if (e.view.scrollY + e.deltaY > this.scrolls[0][1]) this.viewBtn = true;
      else this.viewBtn = false;

      if (this.$modals.get().length || this.scrollAnimation) return;
      const curScrollHeight = e.view.scrollY + 10 + (this.readonly ? 0 : 64);
      const { deltaY } = e;
      const isDown = deltaY > 0;

      const isScrollInSection = (height, [start, end]) => height > start && height < end;
      const scrollTo = async (top, event) => {
        this.scrollAnimation = true;
        event.preventDefault();
        await this.$vuetify.goTo(top, { duration: 750, easing: 'easeInOutCubic', offset: 0 });
        this.scrollAnimation = false;
      };

      if (isDown) {
        const bottomHeight = curScrollHeight + (window.innerHeight * 0.85);
        const [, sectionEnd] = this.scrolls
          .find((item) => isScrollInSection(curScrollHeight, item));

        const isChangeSection = bottomHeight + deltaY > sectionEnd;
        if (isChangeSection) scrollTo(sectionEnd, e);
      } else {
        const curScrollHeightBottom = e.view.scrollY + window.innerHeight - 10;
        const currentScroll = this.scrolls
          .find((item) => isScrollInSection(curScrollHeightBottom, item));

        const [sectionStart] = currentScroll || this.scrolls[this.scrolls.length - 1];

        const isChangeSection = curScrollHeight + deltaY < sectionStart;
        if (isChangeSection) scrollTo(sectionStart - window.innerHeight, e);
      }
    },
    async onExit() {
      await this.save();
      this.onExitMethod();
    },
    parseConstructorData() {
      const {
        titleSection,
        genericSections,
      } = toRepresentationValue(this.constructorData);

      this.titleSection = titleSection;
      this.genericSections = genericSections;
    },
    async save() {
      this.loading.save = true;
      this.genericSections.forEach((section) => {
        const sectionData = this.$refs[`section-${section.hash}`][0];
        section.cards = sectionData.cards || [];
      });
      const payload = toInternalValue(this.titleSection, this.genericSections);
      const { background } = this.titleSection;
      await this.method(payload, background);

      this.loading.save = false;
    },
    scrollToPosition(positionIdx) {
      this.$vuetify.goTo(`#section-${positionIdx}`);
    },
    moveSection(oldPosition, newPosition) {
      const movingElement = this.genericSections[oldPosition];
      this.genericSections.splice(oldPosition, 1);
      this.genericSections.splice(
        newPosition, 0, movingElement,
      );
      this.scrollToPosition(newPosition);
    },
    removeSection(positionIdx) {
      this.genericSections.splice(positionIdx, 1);
    },
    createSection(positionIdx) {
      const { $modals, genericSections, scrollToPosition } = this;
      $modals.show('generic-controller', {
        title: 'Создание секции',
        'dialog-props': {
          maxWidth: 800,
        },
        component: CPickSection,
        'component-props': {
          defaultType: this.defaultType,
          pick(section) {
            genericSections.splice(positionIdx, 0, section);
            $modals.close();
            scrollToPosition(positionIdx);
          },
        },
      });
    },
  },
};
</script>
